import { Alert, Card, Col, Container, Form } from "react-bootstrap";
import Footer from "../../Components/common/Footer";
import Header from "../../Components/common/Header";
import { useLocation } from "react-router-dom";
import "./PaymentRequest.css";
import useAxiosPrivate from "../../Pages/hooks/useAxiosPrivate";
import { BsCoin } from "react-icons/bs";
import { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import { baseURL, PYMENT } from "../../API/API";
import Lodingsubmit from "../../Components/Loding/Loding";

export default function PaymentRequest() {
  const location = useLocation();
  const passedAmount = location.state?.amount || "";
  const passedCourseName = location.state?.courseName || "";

  const [fileName, setFileName] = useState("");
  const fileInputRef = useRef(null);
  const axiosPrivate = useAxiosPrivate();
  const [messages, setmessage] = useState();
  const [loading, setLoading] = useState(false);
  const [Data, setData] = useState({
    amount: passedAmount,
    method: "",
    screenshot: null,
  });

  // Keep Data.amount in sync with passedAmount if location state updates
  useEffect(() => {
    if (passedAmount) {
      setData((prev) => ({ ...prev, amount: passedAmount }));
    }
  }, [passedAmount]);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
      setData({ ...Data, screenshot: file });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData({ ...Data, [name]: value });
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    
    // Validation
    if (!Data.screenshot) {
      toast.error("يرجى رفع صورة الوصل");
      setLoading(false);
      return;
    }
    
    if (!Data.amount || Data.amount <= 0) {
      toast.error("يرجى إدخال مبلغ صحيح");
      setLoading(false);
      return;
    }
    
    if (!Data.method) {
      toast.error("يرجى اختيار طريقة الدفع");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("amount", Data.amount);
    formData.append("method", Data.method);
    formData.append("screenshot", Data.screenshot);

    try {
      const res = await axiosPrivate.post(`${baseURL}/${PYMENT}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      setmessage(res.data.message);
      toast.success("تم استلام طلب الدفع بنجاح");
      
      // Reset form
      setData({
        amount: "",
        method: "",
        screenshot: null,
      });
      setFileName("");
      
    } catch (err) {
      setLoading(false);
      console.error(err);
      const errorMessage = err.response?.data?.message || "حدث خطأ في إرسال الطلب";
      setmessage(errorMessage);
      toast.error(errorMessage);
    }
  }

  return (
    <>
      {loading && <Lodingsubmit />}
      <Header />
      <Container
        className="d-flex justify-content-center align-items-center  animate-card"
        dir="rtl"
      >
        <Card
          className="p-4 shadow-lg payment-card "
          style={{ width: "100%", maxWidth: "500px", margin: "100px 0px" }}
        >
          <Form className="Form w-100" onSubmit={handleSubmit}>
            <p className="fs-3 mb-4 text-center">بيانات الدفع الخاصة بك</p>

            <Form.Group className="floating-label-group mb-4 position-relative">
              <Form.Control
                id="amount"
                className="inpoutFeald ps-5 amount-input"
                type="number"
                name="amount"
                autoComplete="off"
                value={Data.amount}
                onChange={handleInputChange}
                placeholder=" "
                required
                min="1"
                style={{ color: '#032a3d', backgroundColor: '#ffffff' }}
              />
              <Form.Label htmlFor="amount" className="textinpout">
                <BsCoin className="iconeForm " />
                مقدار المبلغ
              </Form.Label>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Select
                id="method"
                required
                name="method"
                autoComplete="off"
                value={Data.method}
                onChange={handleInputChange}
                className="custom-select"
              >
                <option value="">اختر طريقة التحويل</option>
                <option value="vodafone_cash">فودافون كاش (Vodafone Cash)</option>
                <option value="instapay">انستا باي (InstaPay)</option>
                <option value="digital_wallets">محافظ الكترونية أخرى</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3" controlId="uploadImage">
              <div className="upload-wrapper" onClick={handleClick}>
                <div className="upload-display">
                  {fileName || "رفع صورة الوصل"}
                </div>
                <button type="button" className="upload-button">
                  رفع
                </button>
                <input
                  id="screenshot"
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  onChange={handleChange}
                  style={{ display: "none" }}
                  required
                  aria-label="صورة الوصل"
                  autoComplete="off"
                />
              </div>
            </Form.Group>

            <div className="alert alert-danger small mt-3">
              برجاء التأكد من صحة جميع البيانات المرسلة (المبلغ - طريقة التحويل -
              صورة التحويل). أي محاولة إرسال بيانات وهمية أو خاطئة عمدًا قد تؤدي
              إلى إيقاف الحساب وحظرك دائمًا من خدمات المنصة.
            </div>

            <button type="submit" className="btn_submit btn_small ms-auto">
              ارسل طلب
            </button>
          </Form>
          {messages && (
            <Alert
              variant={
                messages.toLowerCase().includes("فشل") ||
                messages.toLowerCase().includes("خطأ")
                  ? "danger"
                  : "success"
              }
              className="mt-3 text-end"
              dir="rtl"
            >
              <div className="fw-bold">{messages}</div>

              {/* ✅ ظهور رسالة ساعات التفعيل عند النجاح */}
              {!(
                messages.toLowerCase().includes("فشل") ||
                messages.toLowerCase().includes("خطأ")
              ) && (
                <div className="mt-2 fw-bold text-success" style={{ fontSize: "1.1rem" }}>
                  ✨ في خلال ساعات سيكون الكورس متوافق عليه ومفتوح لك! سيقوم تيم الدعم الفني بمراجعة التحويل وتفعيل حسابك مباشرة.
                </div>
              )}
            </Alert>
          )}
        </Card>
      </Container>
      <Footer />
    </>
  );
}
